import React from 'react';
import BaseDropdownButton from 'components/atoms/baseButton/dropdown';
import ThreeDotsIcon from 'components/atoms/icons/threeDotsIcon';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

import type { IBaseDropdownButtonProps } from 'components/atoms/baseButton/dropdown';

interface IProps {
  onEdit: () => void;
}

const OptionsCol: React.FC<IProps> = ({ onEdit }) => {
  const { t } = useTranslation();

  const items: IBaseDropdownButtonProps['items'] = [
    {
      key: 'edit',
      label: t('labels.edit'),
      onClick: onEdit,
      className: s['menu-btn'],
    },
  ];

  return (
    <div className={s.options}>
      <BaseDropdownButton type="icon" items={items} icon={<ThreeDotsIcon />} />
    </div>
  );
};

export default OptionsCol;
